/* eslint-disable prettier/prettier */
export default{
    path:"/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    //component: ()=> import(/*webpackChunkName: "Auth Layout"*/ "../../views/crafted/authentication/basic-flow/SingIn.vue"),
    children:[
        {
            path:"/sign-in",
            name:"sign-in",
            component: ()=> import(/*webpackChunkName: "Auth Layout"*/ "../../views/crafted/authentication/basic-flow/SignIn.vue"),
        }
    ]
}